module.exports = __webpack_public_path__ + "img/2-down.cfc21ae3.png";